import { clsx } from 'clsx';
import React, { DetailedHTMLProps, useCallback, HTMLAttributes, MouseEvent, HTMLAttributeAnchorTarget } from 'react';

import styles from './LinkArea.css';

interface ILinkAreaProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  href?: string;
  rel?: string;
  preventDefault?: boolean;
  target?: HTMLAttributeAnchorTarget;
}

export function LinkArea({ href, rel, children, preventDefault, target, ...divProps }: ILinkAreaProps) {
  const onLinkClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      if (preventDefault) {
        e.preventDefault();
      }
    },
    [preventDefault],
  );

  return (
    <div {...divProps} className={clsx(styles['container'], divProps.className)}>
      {href && (
        <a href={href} className={styles['link']} onClick={onLinkClick} target={target} rel={rel}>
          <span className={styles['link-area']} />
        </a>
      )}
      {children}
    </div>
  );
}
